import BrainLoadingWrapper from '../../../../core/components/molecules/BrainLoading';
import { Typography } from '../../../../core/components/molecules/Typography';
import { DISCIPLINES_MAP } from '../../constants';
import useFlashcardDiscipline from '../../hooks/use-flashcard-discipline';
import DisciplinesFlashCard from '../disciplines-flash-card';
import { useNavigate } from 'react-router-dom';

const TabFlashcards = () => {
  const navigate = useNavigate();
  const { flashcards, isLoading } = useFlashcardDiscipline();

  const items = flashcards
    .filter(({ slug }) => slug)
    .map((discipline) => {
      const bgImage =
        DISCIPLINES_MAP[discipline.slug as keyof typeof DISCIPLINES_MAP]
          .bgImage;
      const gradient =
        DISCIPLINES_MAP[discipline.slug as keyof typeof DISCIPLINES_MAP]
          .gradient;

      return (
        <DisciplinesFlashCard
          key={discipline.uuid}
          title={discipline.name}
          bgImage={bgImage}
          gradient={gradient}
          qtd={discipline?.flashcards?.length || 0}
          onClick={() => {
            navigate(`/memory/flashcards/${discipline.uuid}`);
          }}
        />
      );
    });

  return (
    <div className='flex w-full flex-col gap-2'>
      <Typography className='text-h5 font-bold text-mono-color-darker'>
        Meus <i>Flashcards</i>
      </Typography>

      {isLoading ? (
        <div className='flex h-[174px] w-full items-center justify-center '>
          <BrainLoadingWrapper customMessage='Carregando decks...' />
        </div>
      ) : (
        <div className='mb:p-8 grid grid-cols-[repeat(auto-fill,minmax(125px,125px))] justify-center gap-8 rounded-[32px] bg-mono-color-lighter p-2'>
          {items}
        </div>
      )}
    </div>
  );
};

export default TabFlashcards;
